module.exports = __webpack_public_path__ + "static/media/TREVORS TANK SMALL AND BIG.e9d1b723.png";